import { useEffect, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";
import { Button } from "../buttons/shadcn-button";
import { cn } from "src/utils";
import { Input } from "../input/input";


interface TimePickerProps {
  value?: string;
  onChange: (value: string) => void;
}

export function TimePicker({ value, onChange }: TimePickerProps) {
  const [open, setOpen] = useState(false);

  // Extract hours, minutes, seconds from current value or default
  const [hours, setHours] = useState("00");
  const [minutes, setMinutes] = useState("00");
  const [seconds, setSeconds] = useState("00");

  useEffect(() => {
    if (value && /^\d{2}:\d{2}:\d{2}$/.test(value)) {
      const [h, m, s] = value.split(":");
      setHours(h);
      setMinutes(m);
      setSeconds(s);
    }
  }, [value]);

  const applyTime = () => {
    const formatted = `${hours}:${minutes}:${seconds}`;
    onChange(formatted);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            "w-[140px] justify-start font-mono",
            !value && "text-muted-foreground"
          )}
        >
          {value || "HH:mm:ss"}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-4">
        <div className="grid grid-cols-3 gap-2">
          {/* Hours */}
          <div>
            <label className="block text-xs font-medium mb-1">HH</label>
            <Input
              type="number"
              min={0}
              max={23}
              value={hours}
              onChange={(e) =>
                setHours(e.target.value.padStart(2, "0").slice(-2))
              }
            />
          </div>

          {/* Minutes */}
          <div>
            <label className="block text-xs font-medium mb-1">MM</label>
            <Input
              type="number"
              min={0}
              max={59}
              value={minutes}
              onChange={(e) =>
                setMinutes(e.target.value.padStart(2, "0").slice(-2))
              }
            />
          </div>

          {/* Seconds */}
          <div>
            <label className="block text-xs font-medium mb-1">SS</label>
            <Input
              type="number"
              min={0}
              max={59}
              value={seconds}
              onChange={(e) =>
                setSeconds(e.target.value.padStart(2, "0").slice(-2))
              }
            />
          </div>
        </div>

        <Button className="w-full mt-4" onClick={applyTime}>
          Set Time
        </Button>
      </PopoverContent>
    </Popover>
  );
}